import * as React from 'react';
import { ChildProps, graphql } from 'react-apollo';
import track from 'react-tracking';
import { CoreBumpRecommendationListing } from '../../schemas/rql';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { ProductPageBumpV2 } from './product_page_bump_v2';
import { trackEvent } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';
import { BUMPED_LISTING_RECOMMENDATION_QUERY } from './bump_listing_query';
import { formatBid } from './bump_helpers';

interface AdminBidPropType {
  bid: number;
  expiresAt?: string;
}

interface ExternalProps extends IUserContext {
  listingId: string;
  listingSoldWithBump: boolean;

  // in the near future these could be hardcoded here instead of coming from core
  bidTiers: Array<string>[];
  tierIncrement: number;

  // these need to come from core for now
  bid: number;
  adminBid?: AdminBidPropType;
  impressions?: number;
  salesCount?: number;
  salesSpent?: string;
  salesRevenue?: string;
}

type Props = ChildProps<ExternalProps, CoreBumpRecommendationListing.Query>;

interface State {
  bid: number;
}

const COMPONENT_NAME = 'ProductPageBump';

@track({
  componentName: COMPONENT_NAME,
})
export class BumpDisplay extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      bid: this.props.bid,
    };
  }

  componentDidMount() {
    if (this.listing) {
      this.logView();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.listing?.id && this.listing?.id !== prevProps.data?.listing?.id) {
      this.logView();
    }
  }

  logView() {
    trackEvent({
      eventName: MParticleEventName.ViewedBumpDisplay,
      listing: this.listing,
      startingBumpRatePercent: formatBid(this.props.bid),
    });
  }

  get displayBumpBanner() {
    return this.isLive && !this.props.listingSoldWithBump;
  }

  get displayBumpModal() {
    if (
      this.listing?.bumpEligible

    ) { return false; }

    return this.isDraft;
  }

  get isLive(): boolean {
    return this.listing?.state === 'live';
  }

  get isDraft(): boolean {
    return this.listing?.state === 'draft';
  }

  get listing() {
    return this.props.data?.listing;
  }

  render() {
    if (!this.listing) return null;
    return (
      <ProductPageBumpV2
        bid={this.state.bid}
        listing={this.listing}
        showModal={this.displayBumpModal}
        impressions={this.props.impressions}
        salesCount={this.props.salesCount}
        salesSpent={this.props.salesSpent}
        salesRevenue={this.props.salesRevenue}
      />
    );
  }
}

const withQuery = graphql<ExternalProps, CoreBumpRecommendationListing.Query>(
  BUMPED_LISTING_RECOMMENDATION_QUERY,
  {
    options: (ownProps) => {
      return {
        errorPolicy: 'all',
        variables: {
          id: ownProps.listingId,
        },
      };
    },
  },
);

export default withUserContext(withQuery(BumpDisplay));



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/bump_display.tsx